export default __webpack_public_path__ + "static/media/pagimovel-logo.db008fec.svg";